"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsFormKey = exports.settingsSchema = exports.settingsFormFields = void 0;
const zod_1 = require("zod");
const checkbox_size_1 = require("@App/enum/checkbox-size");
const form_field_types_1 = require("@App/enum/form-field-types");
const populate_schema_1 = __importDefault(require("@App/forms/v2/helpers/populate-schema"));
const termsAndConditionsKey = 'termsAndConditions';
const privacyPolicyKey = 'privacyPolicy';
const emailCommunicationsKey = 'emailCommunications';
const searchTermsAndConditionsKey = 'searchTermsAndConditions';
const showWelcomePopupKey = 'showWelcomePopup';
const mfaBySmsKey = 'mfaBySms';
const mfaByEmailKey = 'mfaByEmail';
const showDetailedWorkCardsKey = 'showDetailedWorkCards';
const settingsFormKey = 'settingsForm';
exports.settingsFormKey = settingsFormKey;
const settingsSchema = zod_1.z.object({
    [termsAndConditionsKey]: zod_1.z.boolean(),
    [privacyPolicyKey]: zod_1.z.boolean(),
    [emailCommunicationsKey]: zod_1.z.boolean(),
    [searchTermsAndConditionsKey]: zod_1.z.boolean(),
    [showWelcomePopupKey]: zod_1.z.boolean(),
    [mfaBySmsKey]: zod_1.z.boolean(),
    [mfaByEmailKey]: zod_1.z.boolean(),
    [showDetailedWorkCardsKey]: zod_1.z.boolean(),
});
exports.settingsSchema = settingsSchema;
const settingsFieldsNoSchema = {
    [termsAndConditionsKey]: {
        name: termsAndConditionsKey,
        parentObjectName: settingsFormKey,
        label: 'Accept',
        size: checkbox_size_1.CheckboxSize.small,
        checked: false,
        type: form_field_types_1.FormFieldTypes.CHECKBOX,
    },
    [privacyPolicyKey]: {
        name: privacyPolicyKey,
        parentObjectName: settingsFormKey,
        label: 'Accept',
        size: checkbox_size_1.CheckboxSize.small,
        checked: false,
        type: form_field_types_1.FormFieldTypes.CHECKBOX,
    },
    [emailCommunicationsKey]: {
        name: emailCommunicationsKey,
        label: 'Enroll in marketing communications',
        parentObjectName: settingsFormKey,
        size: checkbox_size_1.CheckboxSize.small,
        checked: false,
        type: form_field_types_1.FormFieldTypes.CHECKBOX,
    },
};
const settingsFormFields = (0, populate_schema_1.default)(settingsFieldsNoSchema, settingsSchema);
exports.settingsFormFields = settingsFormFields;
